import actions from './actions';


export default {
  toggleModal: actions.toggleModal,
  zipCheck: actions.zipCheck,
  deliveryRequest: actions.deliveryRequest,
};
